import { createToastComponents } from '@workday/upc-common';

export type ToastType = 'success' | 'error';

export type WclToastData = {
    type?: ToastType;
    text: string;
    translationKey?: string;
};

const components = createToastComponents<WclToastData>();

export const toastSlice = components.createSlice({ name: 'toast' });
export const toastActions = toastSlice.actions;
export const toastAdapter = components.adapter;
